import React from 'react';
import { Box, Title, Grid, TextInput, Group, Skeleton, Paper, Button } from '@mantine/core';
import { IconFilter, IconSearch } from '@tabler/icons';
import { useAvailableIntegrations, useConnectedIntegrations } from '../../../../hooks/useIntegrations';
import { IntegrationCard } from '../components/IntegrationCard';
import { useState } from 'react';
import { IgnoreAccountIdsModal } from '../components/IgnoreAccountIdsModal';

export const IntegrationsList: React.FC = () => {
  const { data: availableIntegrations, isLoading } = useAvailableIntegrations();
  const { data: connectedIntegrations } = useConnectedIntegrations();
  const [searchQuery, setSearchQuery] = useState('');
  const [ignoreAccountsModalOpen, setIgnoreAccountsModalOpen] = useState(false);

  const filteredIntegrations = availableIntegrations?.filter(integration => {
    // For "api" integration, only show if it's connected
    if (integration.key === 'api') {
      const isApiConnected = connectedIntegrations?.some(
        (conn) => conn.key === 'api' && ['active', 'setup'].includes(conn.status || '')
      );
      if (!isApiConnected) {
        return false;
      }
    }
    
    // Apply search filter
    return integration.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
           integration.description.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const LoadingSkeleton = () => (
    <>
      {[1, 2, 3, 4].map((i) => (
        <Grid.Col key={i} xs={12} sm={6} md={6} lg={4} xl={3}>
          <Paper shadow="sm" p="lg" radius="md" withBorder>
            <Group position="apart" mb="md">
              <Group>
                <Skeleton height={40} circle />
                <Box>
                  <Skeleton height={20} width={120} mb="sm" />
                  <Skeleton height={16} width={200} />
                </Box>
              </Group>
              <Skeleton height={20} width={80} />
            </Group>
            <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Skeleton height={36} width={100} />
            </Box>
          </Paper>
        </Grid.Col>
      ))}
    </>
  );

  return (
    <Box p="md">
      <Group position="apart" align="self-start">
        <Box mb="xl">
          <Title order={2} mb="md">Available Integrations</Title>
        
          <TextInput
            placeholder="Search integrations..."
            icon={<IconSearch size={14} />}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.currentTarget.value)}
            style={{ flex: 1 }}
          />
          
        </Box>
        <Button
          variant="outline"
          onClick={() => setIgnoreAccountsModalOpen(true)}
          leftIcon={<IconFilter size={16} />}
        >
            Global Filter
        </Button>
      </Group>
      
      <Grid grow>
        {isLoading ? (
          <LoadingSkeleton />
        ) : (
          filteredIntegrations?.map((integration) => (
            <Grid.Col key={integration._id?.toString() || ''} xs={12} sm={6} md={6} lg={4} xl={3}>
              <IntegrationCard integration={integration} />
            </Grid.Col>
          ))
        )}
      </Grid>

      <IgnoreAccountIdsModal
        opened={ignoreAccountsModalOpen}
        onClose={() => setIgnoreAccountsModalOpen(false)}
      />
    </Box>
  );
};

export default IntegrationsList; 